export const urlVehicleSearch = '/api/search/vehicle';
export const urlVehicle = '/api/vehicle';
export const urlParamDevice = 'api/vehicle/param';